import { Component, Input, NgZone, ViewChild, ElementRef } from '@angular/core';
import {Http, Headers, Response} from '@angular/http';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map'
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { httpService } from '../service/servicio'
import { LoginComponent } from '.././login/login.component'
import { UPLOAD_DIRECTIVES} from 'ng2-uploader';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ViewContainerRef } from '@angular/core';
import { NgxPaginationModule } from 'ngx-pagination';
import { AppComponent } from '../app.component'
import { parametros } from '../datos/parametros';

import * as jsPDF from 'jspdf'

//declare var jsPDF: any;

//import * as html2canvas from "html2canvas"

//declare var jsPDF: any;

@Component({
  selector: 'app-body',
  templateUrl: 'body.component.html',
})

export class bodyComponent {

  @ViewChild('content') content: ElementRef;

constructor (private http: httpService,  public toastr: ToastsManager, vcr: ViewContainerRef, private elem: ElementRef) {

    this.toastr.setRootViewContainerRef(vcr);
    this.descargarMaquinas();
    this.orden(5);
    this.leerestado();


  };

  uploaded = {
    Status:0,
    Text:''

  }

  @Input() posiciones:any = [];
  @Input() maquinas: any = [];
  @Input() marcas: any = [];
  @Input() modelos: any;



  maquinaSearch: string ='';
  place:string = 'Buscar por Cliente';

  mostrarLogin = true;
  confirmar:boolean = false;
  mostrarVehiculo:boolean = false;
  mostrarExpedientes:boolean = false;
  mostrarDetalle:boolean = false;
  mostrarDetalleExpediente:boolean = false;
  mostrarDoc:boolean = false;
  mostrarUpload:boolean = false;
  mostrarBorrar:boolean = false;
  haydocs:boolean = false;


  enviando:string = 'Correo OK!';
  enviado:boolean = true;
  contador: Number;
  estadoCargar: string = 'Loading';
  estadoCancel: string = 'Cancelar';
  sort: string = 'Descmarca';

  mensajeAlerta:string;
  logged:string;
  ficheroBorrar:string = '';
  tituloexpediente:string = 'Editar Expediente';

  titulo:string = "Mi titulo";
  mensaje:string = "Mi mensaje";
  boton:string = "Este es mi boton";
  user:string = '';
  pass:string = '';
  foto:string ='';
  editando:boolean = true;
  editandoExpediente:boolean= false;
  conf:any;
  activadas: boolean;
  botonactivada:string = "Desactivar"

  icon1:string ="glyphicon glyphicon-edit";

  orden(n) {
    if (n == 1) { this.sort='Id'; this.place='Buscar por Id' };
    if (n == 2) { this.sort='Descmarca'; this.place='Buscar por Marca' };
    if (n == 3) { this.sort='Descmodelo'; this.place='Buscar por Modelo' };
    if (n == 4) { this.sort='DescPosicion'; this.place='Buscar por Posicion' };
    if (n == 5) { this.sort='Desccliente'; this.place='Buscar por Cliente' };
    if (n == 6) { this.sort='descripcion'; this.place='Buscar por Descripcion' };
    this.ordenar(this.sort);

  }

 quitarfiltro(tipo: Number) {
    this.maquinaSearch = '';
 }

 leerestado(){
   this.http.leerActivarMaquinas()
     .subscribe(conf => {
           this.conf = conf;
           console.log(this.conf)
     }, err => {
            (err.message);
     }, () => {
              if (this.conf.verActiva == 1) {
                this.botonactivada = "Activar Máquinas";
                this.activadas = true;
              }
              else {
                this.botonactivada = "Desactivar Máquinas";
                this.activadas = false;
              }
          });
 }

 activar() {
   this.http.leerActivarMaquinas()
     .subscribe(conf => {
           this.conf = conf;
           console.log(this.conf)
     }, err => {
            (err.message);
     }, () => {
           console.log("Activa: ", this.conf.verActiva)
           if (this.conf.verActiva == 1 ) {
             this.http.grabarConf(0).subscribe(data=>
               {
                 this.toastr.success('Maquinas Activadas','Activacion');
                 this.botonactivada = "Desactivar Máquinas";
                 this.activadas = true;
                 this.descargarMaquinas();
               });

           }
           else {
             this.http.grabarConf(1).subscribe(data=>
               {
                 this.toastr.success('Maquinas Desactivadas','Activacion');
                 this.botonactivada = "Activar Máquinas";
                 this.activadas = false;
                 this.descargarMaquinas();
               });
           }


     });

 }

filtro() {
    return this.maquinas.filter((maquina) => {
       if (this.sort == 'Id')
          return maquina.Id.toLowerCase().indexOf(this.maquinaSearch.toLowerCase()) != -1;
       if (this.sort == 'Descmarca')
          return maquina.Descmarca.toLowerCase().indexOf(this.maquinaSearch.toLowerCase()) != -1;
      if (this.sort == 'Descmodelo')
          return maquina.Descmodelo.toLowerCase().indexOf(this.maquinaSearch.toLowerCase()) != -1;
      if (this.sort == 'DescPosicion') {
        if (maquina.DescPosicion == null ) maquina.DescPosicion = 'Sin asignar';
        return maquina.DescPosicion.toLowerCase().indexOf(this.maquinaSearch.toLowerCase()) != -1;
      }
      if (this.sort == 'Desccliente') {
        if (maquina.Desccliente == null ) maquina.Desccliente = 'Sin asignar';
        return maquina.Desccliente.toLowerCase().indexOf(this.maquinaSearch.toLowerCase()) != -1;
      }
      if (this.sort == 'descripcion') {
        if (maquina.Desccliente == null ) maquina.descripcion = 'Sin asignar';
        return maquina.descripcion.toLowerCase().indexOf(this.maquinaSearch.toLowerCase()) != -1;
      }
   });
}

ordenar(sort) {

  let campo1, campo2: any;

  this.maquinas.sort(function(a, b){

    switch (sort) {
    case "Id":
      campo1 = a.Id;
      campo2 = b.Id;
      break;
    case "Descmarca":
      campo1 = a.Descmarca;
      campo2 = b.Descmarca;
      break;
    case "Descmodelo":
    campo1 = a.Descmodelo;
    campo2 = b.Descmodelo;
      break;
    case "descripcion":
    campo1 = a.descripcion;
    campo2 = b.descripcion;
      break;
    case "Desccliente":
    campo1 = a.Desccliente;
    campo2 = b.Desccliente;
      break;
    case "DescPosicion":
     campo1 = a.DescPosicion;
     campo2 = b.DescPosicion;
        break;
    default:
  }

    if ( campo1 < campo2 )
        return -1;
    if ( campo1 > campo2 )
        return 1;
    return 0;
  });

}

listar() {

  // Only pt supported (not mm or in)

  let doc = new jsPDF('p', 'pt');

  doc.setFont("courier");
  doc.setFontSize(14);
  doc.setFontType("bold");

  doc.text(15,20,"Listado de Máquinas ( " + this.filtro().length + " )")
  doc.text(500, 20, this.http.hoy())
  doc.line(15,25,585,25);

  let lineas:any = [];
  let y: number = 40;

  doc.setFontSize(10);
  doc.setFontType("normal");
/*
  doc.text(0,5, '12345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890');
  doc.text(0,15,'         1         2         3         4         5         6         7         8         9         10       11        12        13        14');
  for (let i=0; i < 800; i+=10) {

    doc.text(i, 25,".");
    doc.text(5,i,".");
  }
  let ii:number = 0;
  let c:number = 0;

  for (let i=0; i < 800; i+=10) {
    ii ++;
    if (ii == 10) {
      c++;
      doc.text(i, 25, c.toString());
      doc.text(10, i, c.toString());

      ii = 0 };

  }
*/
  doc.setFontSize(10);
  doc.setFontType("bold");

  doc.text(15, y, 'Id');
  doc.text(40, y, 'Marca');
  doc.text(100, y, 'Modelo');
  doc.text(200, y, 'Descripcion');
  doc.text(350, y, 'Cliente');
  doc.text(550, y, 'Visita');
  doc.line(15, y + 5, 585, y + 5)

 y = 60;
 doc.setFontType("normal");
 let sw:boolean =true;

let tabla:any = this.filtro();


  tabla.forEach(maquina => {
    if (sw) {
     doc.setTextColor(128,128,128)
   }else {
     doc.setTextColor(0,0,0)
   }

   doc.text(15, y, maquina.Id);
   doc.text(40, y, maquina.Descmarca.slice(0,10));
   doc.text(100, y, maquina.Descmodelo.slice(0,14));
   doc.text(200, y, maquina.descripcion.slice(0,15));
   doc.text(300, y, maquina.Desccliente.slice(0,35));
   doc.text(550, y, maquina.dias);
   //doc.line(15, y + 8, 585, y + 8)


   sw = !sw;

   y+=20;
   if (y > 800)  { doc.addPage(); y = 35 }

  })


    doc.save('Maquinas.pdf');

}


descargarMaquinas() {
  this.http.loading = true;
  this.http.descargarMaquinas(0)
      .subscribe(maquina => {
                 this.maquinas = maquina;
                  console.log(this.maquinas);
                  this.http.loading = false;
            }, err => {
              this.http.loading = false;
                  this.titulo = err.message;
                   (err.message);
            }, () => {

            });
}

leeMarcas() {
  this.http.descargarMarcas()
    .subscribe(marca => {
          this.marcas = marca;
           (this.marcas);
    }, err => {
           (err.message);
    }, () => {
           ('marcas Cargadas');
    });

}

leemodelos() {
    this.http.descargarPosiciones()
    .subscribe(empresa => {
        this.modelos = empresa;
         (this.modelos);
    }, err => {
         (err.message);
    }, () => {
         ('modelos Cargadas');
    });
}


pulsado(maquina) {
    this.toastr.warning("Cargando...", "Internet");
    if (maquina.visitas === '') maquina.visitas = 'FFFFFFFFFFF';
    this.http.maquinaGrabar = maquina;
    this.http.maquinaGrabar.observaciones = this.http.miReplace(this.http.maquinaGrabar.observaciones, "$", "\r");
    console.log(this.http.maquinaGrabar)
    this.http.sw.mostrarDatosmaquinas = true;
}


crearMaquina() {
   this.http.maquinaGrabar = this.http.nuevaMaquina();
   this.http.sw.mostrarDatosmaquinas = true;
   this.http.sw.mostrarMaquinas = false;
   this.http.sw.mostrarMenu = false;
}


}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/duran/duran-web/src/app/components/body.component.ts